import { ariaSet, ariaGetControlledElement } from '@vo/js/utils/aria'
import { elementIsFirst, elementIsLast, getSiblings } from '@vo/js/utils/helpers'

export default (function () {
    function init(module) {
        const tabs = module.querySelectorAll('[role="tab"]')

        tabs.forEach((tab) => bindTabEvents(tab))
    }

    function bindTabEvents(tab) {
        tab.addEventListener('click', handleClick)
        tab.addEventListener('keydown', handleKeydown)
    }

    function handleClick(event) {
        const tab = event.currentTarget
        const siblings = getSiblings(tab)

        if (tab.getAttribute('aria-selected') !== 'true') {
            open(tab)
            siblings.forEach((sibling) => close(sibling))
        }
    }

    function handleKeydown(event) {
        const tab = event.currentTarget
        const isFirst = elementIsFirst(tab)
        const isLast = elementIsLast(tab)

        if (event.code === 'ArrowRight') {
            isLast ? tab.parentNode.firstElementChild.focus() : tab.nextElementSibling.focus()
        }

        if (event.code === 'ArrowLeft') {
            isFirst ? tab.parentNode.lastElementChild.focus() : tab.previousElementSibling.focus()
        }

        if (event.code === 'Home') {
            tab.parentNode.firstElementChild.focus()
        }

        if (event.code === 'End') {
            tab.parentNode.lastElementChild.focus()
        }
    }

    function open(tab) {
        ariaSet('selected', tab, 'true')
        tab.removeAttribute('tabindex')
        tab.focus()
        ariaGetControlledElement(tab)?.classList.remove('hidden')
    }

    function close(tab) {
        ariaSet('selected', tab, 'false')
        tab.setAttribute('tabindex', -1)
        ariaGetControlledElement(tab)?.classList.add('hidden')
    }

    const modules = document.querySelectorAll('[data-module="tabs"]')

    modules.forEach((module) => init(module))
})
